<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputStreet" });
import { InputText } from "../../../../inputs/index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
</script>

<InputText
    bind:value
    placeholder = 'resource.address.properties.street.placeholder'
    label = 'resource.address.properties.street.label'
    name = 'address.street'
    minLength = { 3 }
    { isDisabled }
    { isReadonly }
    { isRequired }
/>